// @flow
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import cx from 'classnames';

import Checkbox from 'components/Checkbox';
import { DisabledTooltipLayer } from './SelectFromList';
import EventTracking from 'lib/EventTracking';
import GroupChatAvatar from 'chat/components/GroupChatAvatar';
import MediaObject from 'components/MediaObject';
import { selectRecipient } from 'reducers/roleBasedMessagingSearch';
import Text from 'components/Text';
import { ComposerContext } from './ComposerContext';
import type { UIEventContext } from './ComposerContext';

import type { GroupChatRecipient, MessageFilterType } from 'reducers/roleBasedMessagingSearch';

type Props = {
  recipient: GroupChatRecipient,
  recipientIsSelected: boolean,
  disabledCopy: ?string,

  // Redux dispatchers
  onSelectRecipient: (recipient: GroupChatRecipient, filter: ?MessageFilterType) => *,
};

class GroupChatRecipientItem extends React.Component<Props, *> {
  logSelectionEvent = (uiEventContext: UIEventContext) => {
    if (this.props.recipientIsSelected) {
      EventTracking.trackKey('announcements.share_to.group_chat.unselect.click', uiEventContext);
      return;
    }
    EventTracking.trackKey('announcements.share_to.group_chat.select.click', uiEventContext);
  };

  handleSelection = () => {
    this.props.onSelectRecipient(this.props.recipient, undefined);
  };

  render() {
    const { recipient, disabledCopy } = this.props;
    const { chat } = recipient;
    const numberOfOtherRecipients = chat.getMembershipsCount() - 1;
    const component = (
      <ComposerContext.Consumer>
        {composerContext => (
          <li
            className={cx('RecipientItem', {
              'RecipientItem--disabled': !!disabledCopy,
            })}
            onClick={() => {
              this.handleSelection();
              this.logSelectionEvent(composerContext.getUIEventContext());
            }}>
            <MediaObject figure="right" center>
              <MediaObject gutter="small" center>
                <GroupChatAvatar size="medium" />
                <div>
                  <Text size="small" element="div" truncate>
                    {chat.getTitle()}
                  </Text>
                  <Text size="xsmall" element="div" color="eclipse">
                    {numberOfOtherRecipients} people
                  </Text>
                </div>
              </MediaObject>
              <Checkbox onChange={this.handleSelection} checked={this.props.recipientIsSelected} />
            </MediaObject>
          </li>
        )}
      </ComposerContext.Consumer>
    );
    return disabledCopy ? (
      <DisabledTooltipLayer text={disabledCopy}>{component}</DisabledTooltipLayer>
    ) : (
      component
    );
  }
}

const mapDispatchToProps = (dispatch: Function) => {
  return bindActionCreators(
    {
      onSelectRecipient: selectRecipient,
    },
    dispatch
  );
};

export { GroupChatRecipientItem };

export default connect(
  undefined,
  mapDispatchToProps
)(GroupChatRecipientItem);
